import { VKShare, OKShare } from '../../../js/sharing';

export const handleShare = () => {
  const vkButton = document.getElementById('vk-share');
  const okButton = document.getElementById('ok-share');

  vkButton.addEventListener('click', () => {
    const header = document.getElementById('share-header');
    const banner = document.getElementById('share-img');

    const url = window.top.location.href;
    const description = header.textContent;
    const image = banner.getAttribute('src');
    VKShare(url, description, image);
  });

  okButton.addEventListener('click', () => {
    const url = window.top.location.href;
    OKShare(url);
  });
};
